<div class="container-fluid">
  <div class="row">
    <div class="col">
      <app-eca-select [controlId]="'ctrlBusinessUnit'"
                      [options]="allBusinessUnits"
                      [(selectedId)]="tempEngagement.businessUnitId"
                      [isRequired]="false"
                      label="Business Unit"
                      placeholderText="Select a Value"
                      [isReadOnly]="!isEditing || allBusinessUnits?.length < 1"
                      [popoverText]=businessUnitHelpText>
      </app-eca-select>      
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-eca-select [controlId]="'ctrlOperativeType'"
                      [options]="allOperativeTypes" [(selectedId)]="selectedOperativeTypeId" (selectedIdChange)="updateJobTitles($event,true)"
                      [isRequired]="true"
                      label="Operative Type"
                      [isReadOnly]="!isEditing"
                      [isValid]="!saveAttempted || !!selectedOperativeTypeId"
                      validationMessage="Please select an option"
                      popoverText="Select the Type that best suits the Operatives current role">
      </app-eca-select>      
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-eca-select [controlId]="'ctrlJobTitle'"
                      [options]="filteredJobTitles" [(selectedId)]="selectedJobTitleId" (selectedIdChange)="updateJobLevel($event,true)"
                      [isRequired]="true"
                      label="Job Role"
                      [isReadOnly]="!isEditing"
                      [isValid]="!saveAttempted || !!selectedJobTitleId"
                      [showUpdateMessage]="showJobTitleUpdate"
                      [updateMessage]="'Job Title was updated after Operative Type change.'"
                      validationMessage="Please select an option"
                      popoverText="Choose the Job Role that best fits the operative's role">
      </app-eca-select>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-eca-select [options]="filteredJobLevels" [(selectedId)]="this.tempEngagement.jobLevelId"
                      [isRequired]="true"
                      label="Job Level"
                      [isReadOnly]="!isEditing || isNonElectricalJobRole || isQsRole"
                      [isValid]="!saveAttempted || !!selectedJobLevelId"
                      [showUpdateMessage]="showJobLevelUpdate"
                      [updateMessage]="'Job Level was updated after Job Role change.'"
                      validationMessage="Please select an option"
                      popoverText="Select the level the operative is currently working at. This level will default to the job role's level but can be overriden">
      </app-eca-select>      
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-eca-select [controlId]="'ctrlJobRisk'"
                      [options]="filteredRisks" [(selectedId)]="this.tempEngagement.riskId"
                      [isRequired]="true"
                      label="Degree of Risk in the Electrotechnical Work"
                      [isReadOnly]="!isEditing || isNonElectricalJobRole"
                      [isValid]="!saveAttempted || !!selectedRiskId"
                      [showUpdateMessage]="showRiskUpdate"
                      [updateMessage]="'Updated after Job Level change.'"
                      validationMessage="Please select an option"
                      popoverText="Please enter the Degree of Risk in the Electrotechnical Work covered by BS 7671 that the operative is currently engaged in.">
      </app-eca-select>      
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <app-eca-date-picker [isDisabled]="!isEditing"
                           [controlId]="'ctrlEngagementFrom'"
                           (dateValueChange)="disableDatesPriorSelected(tempEngagement.from)"
                           [dateValue]="tempEngagement.from"
                           [maxDate]="operativeMaxDate"
                           label="Start Date"
                           [isValid]="!saveAttempted || !!tempEngagement.from?.dateTime"
                           validationMessage="Please enter the date that these changes are effective from"
                           [isRequired]="true"
                           popoverText="Please enter the date that these operative details are active from. This could be the work start date for the operative or when they change job role etc.">
      </app-eca-date-picker>
    </div>
    <div class="col-md-4">
      <app-eca-date-picker [isDisabled]="!isEditing || tempEngagement?.from?.dateTime === null || tempEngagement?.from?.dateTime === undefined"
                           [controlId]="'ctrlEngagementTo'"
                           (dateValueChange)="disableDatesPostSelected(tempEngagement.to)"
                           [dateValue]="tempEngagement.to"
                           [minDate]="operativeMinDate"
                           label="End Date"
                           [isRequired]="false"
                           popoverText="Please enter the date that this change to the operative ends. You may leave this blank to indicate that the current changes are ongoing.">
      </app-eca-date-picker>

    </div>
    <div class="col-md-4">
      <app-eca-select [options]="allEmploymentStatuses" [(selectedId)]="tempEngagement.employmentStatusId"
                      [isRequired]="true"
                      label="Employment Status"
                      [isReadOnly]="!isEditing"
                      class="full-width-input"
                      [isValid]="!saveAttempted || !!tempEngagement.employmentStatusId"
                      validationMessage="Please select the employment status for the engagement."
                      popoverText="Please select the employment status for the engagement.">
      </app-eca-select>

    </div>
  </div>
</div>
